import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Our-Instructors.module.css";

function InstructorSection() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { t, i18n } = useTranslation("global");
  const [instructors, setInstructors] = useState([]);

  useEffect(() => {
    const fetchInstructors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/instructors`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });

        const data = await response.json();
        setInstructors(data.data);
      } catch (error) {
        console.error("Error fetching instructors:", error);
      }
    };

    fetchInstructors();
  }, [i18n.language]);

  return (
    <section className={styles.ourInstructorsSection}>
      <div className="container">
        <div className={styles.sectionHeader}>
          <h1 className={styles.sectionTitle} >
            {t("ourInstructors.title")}
          </h1>
          <div className={styles.headerContent}>
            <p className={styles.sectionDescription}>{t("ourInstructors.description")}</p>
            <Link to="/Instructors" className={styles.viewAllLink}>
              {t("ourInstructors.view")}
              {localStorage.getItem("lang") === `"ar"` ? (
                <i className="bi bi-arrow-left"></i>
              ) : (
                <i className="bi bi-arrow-right"></i>
              )}
            </Link>
          </div>
        </div>

        <div className={styles.swiperContainer}>
          <button
            ref={prevRef}
            className={styles.customPrevArrow}
            aria-label="Previous slide"
          >
            <i className="bi bi-chevron-right"></i>
          </button>
          
          <button
            ref={nextRef}
            className={styles.customNextArrow}
            aria-label="Next slide"
          >
            <i className="bi bi-chevron-left"></i>
          </button>

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            spaceBetween={20}
            slidesPerView={3}
            breakpoints={{
              1200: { slidesPerView: 4 },
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              0: { slidesPerView: 1 },
            }}
            className="mySwiper"
          >
            {instructors.map((instructor) => (
              <SwiperSlide key={instructor.id}>
                <div className={styles.instructorCard}>
                  <Link to={'/instructortDetails/' + instructor.id}>
                    <div className={styles.instructorImageContainer}>
                      <img
                        src={instructor.image || "assets/imgs/teacger-1.jpg.svg"}
                        className={styles.instructorImage}
                        alt={instructor.name}
                      />
                    </div>
                  </Link>
                  
                  <div className={styles.instructorCardBody}>
                    <Link to={'/instructortDetails/' + instructor.id}>
                      <h5 className={styles.instructorName}>
                        {instructor.name}
                      </h5>
                      <p className={styles.instructorPosition}>
                        {instructor.position}
                      </p>
                    </Link>
                    
                    {/* <div className={styles.socialLinksContainer}>
                      <div className={styles.socialLinks}>
                        {instructor?.facebook && (
                          <a href={instructor.facebook} className={`${styles.socialLink} ${styles.facebook}`} aria-label="Facebook">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        )}

                        {instructor?.twitter && (
                          <a href={instructor.twitter} className={`${styles.socialLink} ${styles.twitter}`} aria-label="X (Twitter)">
                            <i className="fab fa-x-twitter"></i>
                          </a>
                        )}

                        {instructor?.youtube && (
                          <a href={instructor.youtube} className={`${styles.socialLink} ${styles.youtube}`} aria-label="YouTube">
                            <i className="fab fa-youtube"></i>
                          </a>
                        )}

                        {instructor?.tiktok && (
                          <a href={instructor.tiktok} className={`${styles.socialLink} ${styles.tiktok}`} aria-label="TikTok">
                            <i className="fab fa-tiktok"></i>
                          </a>
                        )}

                        {instructor?.whatsapp && (
                          <a href={instructor.whatsapp} className={`${styles.socialLink} ${styles.whatsapp}`} aria-label="WhatsApp">
                            <i className="fab fa-whatsapp"></i>
                          </a>
                        )}

                        {instructor?.telegram && (
                          <a href={instructor.telegram} className={`${styles.socialLink} ${styles.telegram}`} aria-label="Telegram">
                            <i className="fab fa-telegram-plane"></i>
                          </a>
                        )}

                        {instructor?.snapchat && (
                          <a href={instructor.snapchat} className={`${styles.socialLink} ${styles.snapchat}`} aria-label="Snapchat">
                            <i className="fab fa-snapchat-ghost"></i>
                          </a>
                        )}

                        {instructor?.instagram && (
                          <a href={instructor.instagram} className={`${styles.socialLink} ${styles.instagram}`} aria-label="Instagram">
                            <i className="fab fa-instagram"></i>
                          </a>
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default InstructorSection;
